function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 24,
  fill: "#00A94F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1566 12.5431C14.8351 14.5423 12.7552 18.197 12.6408 22.1783L12.3785 22.251C10.4391 22.7923 9.49851 25.6404 10.2689 28.6369C11.0381 31.6316 13.2192 33.6074 15.1592 33.0667L16.3002 32.7465C16.9096 32.5759 17.2069 31.6967 16.9683 30.7719L15.2343 24.0234V22.5283C15.2343 19.3788 16.8441 16.4726 19.4588 14.8967C22.076 13.3201 25.2933 13.3201 27.9098 14.8967C30.5245 16.4726 32.1344 19.3788 32.1344 22.5283V24.0297L30.5015 30.3816C29.8244 31.3044 28.9722 32.0959 27.9746 32.6953C27.4737 32.9985 26.948 33.2322 26.4102 33.4179C26.157 32.9271 25.7639 32.6075 25.3151 32.6075H21.6671C20.8967 32.6075 20.2801 33.536 20.2801 34.6888V34.9193C20.2801 36.0702 20.8967 37 21.6671 37H25.3151C25.8354 37 26.2812 36.5717 26.5192 35.9426C27.4259 35.6881 28.3108 35.3179 29.1466 34.8164C30.0352 34.2814 30.8304 33.6238 31.5245 32.8753L32.2113 33.068C34.1495 33.6087 36.3318 31.6322 37.0998 28.6382C37.8696 25.6417 36.9296 22.7935 34.9896 22.2522L34.7279 22.1777C34.611 18.1964 32.533 14.5429 29.2108 12.5444C27.5016 11.5148 25.5913 11 23.6822 11C21.7743 11 19.8653 11.5142 18.1566 12.5431Z",
  fill: "white"
});

function SvgIconBoxWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxWidgets);
export default __webpack_public_path__ + "static/media/icon_box-widgets.34c05be9.svg";
export { ForwardRef as ReactComponent };